import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function AccessGate() {
  const { user } = useAuth();
  if (!user || ["founder", "admin"].includes(user.role) || user.whitelisted) return null;
  return (
    <div data-testid="access-gate-banner" className="mb-6 rounded-2xl border border-amber-500/40 bg-amber-500/10 p-4 flex items-start gap-3 text-sm">
      <Lock size={16} className="text-amber-300 mt-0.5 shrink-0" />
      <div>
        <div className="font-semibold text-amber-200">Whitelist-only access</div>
        <p className="text-amber-100/80 text-xs mt-0.5">Vectra's creator functions (generation, Executive AI, editing, uploads) are enabled only for whitelisted emails. <span className="font-mono">{user.email}</span> is not whitelisted yet — ask the admin to add you in Admin → Users.</p>
      </div>
    </div>
  );
}
